var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pie-chart-block" },
    [
      _vm.chartTitle
        ? _c("div", {
            staticClass: "w-100 text-center chart-title",
            domProps: { textContent: _vm._s(_vm.chartTitle) }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("pie-chart", {
        staticClass: "p-4",
        attrs: { "chart-data": _vm.chartData },
        on: { legendGenerated: _vm.setLegendHtml }
      }),
      _vm._v(" "),
      _c("div", { domProps: { innerHTML: _vm._s(_vm.legendHtml) } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }